import React from "react";

export default function WebTechComponent() {
  return (
    <div
      className="main_contact_area app pt-40 bg_fixed"
      
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side Image */}
          <div class="col-lg-7 pb-180">  
          <div className="section_main_title black text-left">
                <h5>Deliverables</h5>
          </div>       
            <div class="why-choose-icon " data-wow-delay=".5">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Conduct Contact discovery of provided accounts.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".6">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Find cloud technology of provided organizations & their cloud adoption dates.</h6>
              </div>
              
            </div>
            <div class="why-choose-icon" data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Validate provided emails.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Regularly refresh the fetched data to ensure its relevance and accuracy.</h6>
              </div>
             
            </div>
            
           
            <div className="section_main_title black text-left mt-3">
                <h5>Requirements</h5>
            </div> 
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Experience in contact discovery.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Knowledge about Technographic Data is a big plus.</h6>
              </div>
             
            </div>
            <div class="why-choose-icon " data-wow-delay=".7">
              <div class="choose-icon text-left">
                <span class="chose-icon1"> <i class="fa fa-check"></i></span>
                <h6>Should be good with Advance Excel (Vlookup, Pivot, Dedupe etc).</h6>
              </div>
             
            </div>
           
         
     
 
</div>


          {/* Right Side Contact Form */}
          <div className="col-lg-5">
            <div className="section_title black mb-4">
             
              <div className="section_main_title">
                <h1>Apply Now</h1>
              </div>
            </div>

           
            <iframe
              id="if15on87"
              src="https://fill.formnx.com/f/career-15on87?iframe=true"
             
              frameBorder="0"
              style={{ width: '1px', minWidth: '100%', height: '700px' }}
              title="Career Form"
            />
            <script src="https://formnx.com/js/iframeResizer.js"></script>
            <script src="https://formnx.com/js/widget.js"></script>
          </div>
        </div>
      </div>
    </div>
  );
}
